import { MapTools, ToolboxContainer } from "../minskog/helpers"

const LayerSelector = ({ mapRef, mapTools, setMapTools, setRefresh, setLoading=()=>{} }) => {

    const layerButton = (text, img, action, active, className) => {
        return <div role='button' onClick={action} className={`d-flex flex-column align-items-center mb-1 me-2 ${className ? className : ''}`} style={{ maxWidth: '60px' }}>
            <img src={`${Window.static_path}img/${img}`} className={`rounded ${active ? 'border border-4 border-tertiary-main' : ''}`} height='50px' width='50px' />
            <span className='text-break text-center' style={{ fontSize: '8px' }}>{text}</span>
        </div>
    }

     const editButton = (text, icon, action, className = '', id = null) => {
      return <div id={id} role='button' onClick={action} className={`d-flex flex-column align-items-center justify-content-center rounded bg-white hover-bg-primary-core ${className}`} style={{ width: '60px', height: '60px' }}>
        <img src={`${Window.static_path}img/${icon}`} className='mb-1' height="20px" width="20px" />
        {text}
      </div>
    }

    const checkMapLayerActive = (name) => {
        let found = false

        mapRef.current.state?.mapLayers.eachLayer(l => {
            if (l.name == name) {
                found = true
            }
        })

        return found
    }
    return (
        <MapTools className={`position-absolute z-1010 ${mapTools?.state ? 'show' : ''}`} style={{ left: '50%' }}>
            <div className='d-flex flex-column bg-neutral-cloud shadow rounded-top caption px-2 pt-2'>
                {mapTools?.data === "draw" && (
                    <>
                        <div className='text-center fw-bold mb-1'>Du ritar nu</div>
                        <div className='d-flex pb-2'>
                            {editButton('Spara', 'icons/save.svg', () => { mapRef.current.completeDraw(); setMapTools({ "state": false }); setLoading(true); }, 'me-2')}
                            {editButton('Avbryt', 'icons/ui-close.svg', () => { mapRef.current.stopDraw(); mapRef.current.setMode('view'); setMapTools({ "state": false }); })}
                        </div>
                    </>
                )}

                {mapTools?.data == "layers" && <div className='bg-white p-2'>
                    <div className='mb-2'>Välj bakgrundskarta: <img src={`${Window.static_path}img/icons/cross.svg`} className='float-end' role='button' width='20px' height='20px' onClick={() => setMapTools({ "state": false })} /></div>

                    <div className='d-flex'>
                        {layerButton('Satellit', 'illustration/Mapbox-satelite.png', () => { mapRef.current.setBaseMap('Mapbox Satelite'); setRefresh(true) }, mapRef.current.state.baseMap.name == 'Mapbox Satelite', 'me-2')}

                        {layerButton('Mapbox Plain', 'illustration/Mapbox-plain.png', () => { mapRef.current.setBaseMap('Mapbox Plain'); setRefresh(true) }, mapRef.current.state.baseMap.name == 'Mapbox Plain', 'me-2')}

                        {layerButton('Open Street Map', 'illustration/Open-Street-Map.png', () => { mapRef.current.setBaseMap('Open Street Map'); setRefresh(true) }, mapRef.current.state.baseMap.name == 'Open Street Map')}
                    </div>


                    <div className='mb-2'>Växla lager:</div>

                    <div className='d-flex'>
                        {layerButton('Avverkningsanmälan', 'illustration/Avverkningsanmalan.png', () => { mapRef.current.toggleMapLayer('Avverkningsanmälan'); setRefresh(true) }, checkMapLayerActive('Avverkningsanmälan'), 'me-2')}

                        {layerButton('Utförd avverkning', 'illustration/Utford-avverkning.png', () => { mapRef.current.toggleMapLayer('Utförd avverkning'); setRefresh(true) }, checkMapLayerActive('Utförd avverkning'), 'me-2')}

                        {layerButton('Nyckelbiotoper', 'illustration/Nyckelbiotoper.png', () => { mapRef.current.toggleMapLayer('Nyckelbiotoper'); setRefresh(true) }, checkMapLayerActive('Nyckelbiotoper'), 'me-2')}

                        {layerButton('Fornlämningar', 'illustration/Fornlamningar.png', () => { mapRef.current.toggleMapLayer('Fornlämningar'); setRefresh(true) }, checkMapLayerActive('Fornlämningar'), 'me-2')}

                        {layerButton('Vattenskyddsområden', 'illustration/Vattenskyddsomraden.png', () => { mapRef.current.toggleMapLayer('Vattenskyddsområden'); setRefresh(true) }, checkMapLayerActive('Vattenskyddsområden'), 'me-2')}

                        {layerButton('Object med naturvärde', 'illustration/Object-med-naturvarde.png', () => { mapRef.current.toggleMapLayer('Object med naturvärde'); setRefresh(true) }, checkMapLayerActive('Object med naturvärde'))}
                    </div>

                    <div className='d-flex'>
                        {layerButton('Sumpskog', 'illustration/Sumpskog.png', () => { mapRef.current.toggleMapLayer('Sumpskog'); setRefresh(true) }, checkMapLayerActive('Sumpskog'))}

                        {layerButton('Observationer invasiva arter', 'illustration/Observationer-invasiva-arter.png', () => { mapRef.current.toggleMapLayer('Observationer invasiva arter'); setRefresh(true) }, checkMapLayerActive('Observationer invasiva arter'))}

                        {layerButton('Torvmark', 'illustration/torvmark.png', () => { mapRef.current.toggleMapLayer('Torvmark'); setRefresh(true) }, checkMapLayerActive('Torvmark'))}

                        {layerButton('Observationer rödlistade arter', 'illustration/Observationer-rodlistade-arter.png', () => { mapRef.current.toggleMapLayer('Observationer rödlistade arter'); setRefresh(true) }, checkMapLayerActive('Observationer rödlistade arter'))}

                    </div>
                </div>}

            </div>
        </MapTools>
    )
}

const ZoomAndLayerButtons = ({mapRef,  mapTools, setMapTools, showLegend = { state: false, toggle: false }, setShowLegend =()=>{}}) => {
    
    return (
        <ToolboxContainer className='position-absolute z-1000' style={{ right: "5px" }}>
            <div className='d-flex flex-column bg-neutral-cloud shadow rounded p-1'>
                <div role='button' onClick={() => mapRef.current.zoomIn()} className='d-flex justify-content-center align-items-center bg-white hover-bg-supp-forest-green-300 rounded-1 mb-1' style={{ height: '30px' }}>
                    <img src={`${Window.static_path}img/icons/plus.svg`} height='20px' width='20px' />
                </div>
                <div role='button' onClick={() => mapRef.current.zoomOut()} className={`d-flex justify-content-center align-items-center bg-white hover-bg-supp-forest-green-300 rounded-1 mb-3`} style={{ height: '30px' }}>
                    <img src={`${Window.static_path}img/icons/minus.svg`} height='30px' width='30px' />
                </div>
                <div role='button' onClick={() => { setMapTools( { 'data': 'layers', 'state': true }); mapRef.current.setMode('view'); }} className={`d-flex justify-content-center align-items-center ${mapTools?.data == 'layers' ? 'bg-supp-forest-green' : 'bg-white hover-bg-supp-forest-green-300'} rounded-1 mb-1`} style={{ height: '30px' }}>
                    <img id='leafletLayerButton' src={`${Window.static_path}img/icons/map-layers.svg`} className={mapTools?.data == 'layers' ? 'white-filter' : ''} height='20px' width='20px' />
                </div>
                {showLegend?.state && <div role='button' onClick={() =>{ setShowLegend((prev) => ({...prev, toggle: !prev.toggle}))}} className={`d-flex justify-content-center align-items-center ${showLegend.toggle ? 'bg-supp-forest-green' : 'bg-white hover-bg-supp-forest-green-300'} rounded-1 mb-1`} style={{ height: '30px' }}>
                    <img src={`${Window.static_path}img/icons/info_filled.svg`} className={showLegend.toggle ? 'white-filter' : ''} height='20px' width='20px' />
                </div>}
            </div>
        </ToolboxContainer>
    )
}

export {LayerSelector, ZoomAndLayerButtons};